export default "__VITE_ASSET__BpJ5IQP$__"